import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Text from '../Text/Text';
import "../Pages/page.css"
import { Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import AppealedReplyCitationModal from '../Modals/citation/AppealedReplyCitationModal';
const useStyles = makeStyles((theme) => ({
  bluetitle: {
    fontWeight: 'bold',
    marginTop: '10px',
    fontSize: 16,
  },
  paragraph: {
    fontSize: 10,
  },
  title: {
    fontSize: 14,
    textAlign: 'right',
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'left'
  }
}));
const AppealedCitationCard = (props) => {
  const classes = useStyles();
  const { handleClose, citationDetailState } = props;
  const [isOpenReplyCitationModal, setIsOpenReplyCitationModal] = useState(false);

  const citationCamelCase = (str) => {
    const splitStr = str?.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, " ")?.toLowerCase()?.split(" ");
    // const splitStr = lowerstr?.split(" ");
    for (let i = 0; i < splitStr?.length; i++) {
      if (splitStr[i]?.length > 0) {
        splitStr[i] = splitStr[i][0]?.toUpperCase() + splitStr[i]?.substring(1);
      }
    }
    return splitStr?.join(" ")
  };
  
  const citationResason = (data) => {
    let reasontext = []
    data && data.map((ele) => {
      
      return reasontext.push(ele.text)
    })
    return reasontext.at(-1)
  }

  const handleCloseAppealedReplyCitationModal = () => {
    setIsOpenReplyCitationModal(false)
    handleClose(false)
  }

  const handleCitationReply = () => {
    setIsOpenReplyCitationModal(true)
  }

  
  return (
    <div>
      <Text align={"left"} className={classes.bluetitle} color={"primary"}>
        Appeal Details
      </Text>
      <Divider />
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12}></Grid>
          <Grid item xs={3} className={classes.title}>
            Appeal Date :
          </Grid>
          <Grid item xs={9} className={classes.subtitle}>
            {/* {new Date(citationDetailState.appeal.appealDate).toDateString()} */}
            {new Date(citationDetailState.appeal.appealDate).toLocaleString()}
          </Grid>
          <Grid item xs={3} className={classes.title}>
            Appeal Reasons :
          </Grid>
          <Grid item xs={9} className={classes.subtitle}>
            <div
              className="pmt-p"
              dangerouslySetInnerHTML={{
                __html: citationDetailState.appeal.appealText,
              }}
            ></div>
          </Grid>
          <Grid item xs={3} className={classes.title}>
            Email Address :
          </Grid>
          <Grid item xs={9} className={classes.subtitle}>
            {citationDetailState.appeal.appealFromEmail}
          </Grid>
        </Grid>
      </div>

      <Text align={"left"} className={classes.bluetitle} color={"primary"}>
        Appeal Status
      </Text>
      <Divider />
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12}></Grid>
          <Grid item xs={3} className={classes.title}>
            Hearing Date :
          </Grid>
          <Grid item xs={9} className={classes.subtitle}>
            {/* {citationDetailState && citationDetailState?.appeal && citationDetailState?.appeal?.hearingDate ? new Date(citationDetailState?.appeal?.hearingDate).toDateString() : ""} */}
            {citationDetailState && citationDetailState?.appeal && citationDetailState?.appeal?.hearingDate ? new Date(citationDetailState?.appeal?.hearingDate).toLocaleString() : ""}
          </Grid>
          <Grid item xs={3} className={classes.title}>
            Appeal Decision :
          </Grid>
          <Grid item xs={9} className={classes.subtitle}>
              {citationCamelCase(citationDetailState?.appeal && citationDetailState?.appeal?.pendingDecision?.decision) || citationCamelCase(
                  citationDetailState &&
                    citationDetailState?.appealsStatus
                  )
              }
          </Grid>
          <Grid item xs={3} className={classes.title}>
            Reasoning :
          </Grid>
          <Grid item xs={9} className={classes.subtitle}>
            <div
              className="pmt-p"
              dangerouslySetInnerHTML={{
                __html: citationDetailState?.appeal && citationDetailState?.appeal?.pendingDecision?.note || citationResason(citationDetailState?.appealEntity?.notes)
              }}
            />
          </Grid>
        </Grid>
        {citationDetailState?.appealEntity?.notes?.length ? (
  <Button 
    variant="contained" 
    style={{ float: 'right' }} 
    color="primary" 
    onClick={handleCitationReply}
  >
    Reply
  </Button>
) : null}

      </div>
      <AppealedReplyCitationModal isOpenReplyCitationModal={isOpenReplyCitationModal} handleCloseAppealedReplyCitationModal={handleCloseAppealedReplyCitationModal} citationDetailState={citationDetailState} />
    </div>
  );
}
export default AppealedCitationCard
